import { ReportItemNestedDataGroup } from '@/modules/Reports/report.types';
import { mergeReportNestedItemGroups } from '@/modules/Reports/utils';
import { storeCreator } from '@/utils/store/store.utils';
interface State {
  groups: ReportItemNestedDataGroup[];
  currentPage: number;
  totalPages: number;
  reportDates: [string | undefined, string | undefined];
  isCurrentLoading: boolean;
  pages: number[];
  handleClear: () => void;
  setReportDates: (reportDates: [string | undefined, string | undefined]) => void;
  setGroups: (groups: ReportItemNestedDataGroup[]) => void;
  setCurrentPage: (currentPage: number) => void;
  setTotalPages: (totalPages: number) => void;
  setIsCurrentLoading: (isCurrentLoading: boolean) => void;
  setPages: (page: number) => void;
}

export const usePrefundInvoiceReportStore = storeCreator<State>((set) => ({
  groups: [],
  pages: [],
  currentPage: 0,
  totalPages: 0,
  reportDates: [undefined, undefined],
  isCurrentLoading: false,

  setGroups: (groups: ReportItemNestedDataGroup[]) =>
    set((state) => ({
      ...state,
      groups: mergeReportNestedItemGroups(state.groups, groups),
    })),
  setCurrentPage: (currentPage: number) =>
    set((state) => ({
      ...state,
      currentPage,
    })),
  setTotalPages: (totalPages: number) =>
    set((state) => ({
      ...state,
      totalPages,
    })),
  setReportDates: (reportDates: [string | undefined, string | undefined]) =>
    set((state) => ({
      ...state,
      reportDates,
    })),
  setIsCurrentLoading: (isCurrentLoading: boolean) =>
    set((state) => ({
      ...state,
      isCurrentLoading,
    })),
  setPages: (page: number) =>
    set((state) => ({
      ...state,
      pages: [...state.pages, page],
    })),
  handleClear: () =>
    set((state) => ({
      ...state,
      groups: [],
      pages: [],
      currentPage: 0,
      totalPages: 0,
      reportDates: [undefined, undefined],
      isCurrentLoading: false,
    })),
}));
